
























































import {Vue, Component, Prop} from 'vue-property-decorator';
import {
	ServiceInvoice,
	ServiceRecordDTO,
	UpdateInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import moment from "moment/moment";
import Application from "@/state/Application";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import {prettyEnum} from "@/utils/StringUtils";
import ServiceLogUpdateSlider from "@/components/payroll/business/services/service/ServiceLogUpdateSlider.vue";
import ServiceLogViewSlider from "@/components/payroll/business/services/service/ServiceLogViewSlider.vue";
import RouteNames from "@/router/RouteNames";
import InvoiceService from "@/services/InvoiceService";
import InvoiceDTO, {InvoiceItem} from "@/dto/InvoiceDTO";

export type ServiceInvoiceSide = 'PAYER' | 'PAYEE'

@Component({
	components: {ServiceLogViewSlider, ServiceLogUpdateSlider},
	methods: {
		RouteNames() {
			return RouteNames
		},
		prettyEnum(val: string) {
			return prettyEnum(val)
		}
	},
	computed: {
		moment() {
			return moment
		}
	}
})
export default class ServiceInvoiceItem extends Vue {

	private open = false;
	private updateLog = false
	private viewLog = false;

	private selectedLog: ServiceRecordDTO | InvoiceItem | null = null

	@Prop()
	private invoice!: InvoiceDTO<ServiceRecordDTO | InvoiceItem>

	private req = new UpdateInvoicePayload(
		{
			serviceInvoiceId: this.invoice.id,
			payerId: this.$wss.getCurrent.id
		}
	)

	@Prop({default: 'PAYER'})
	private side!: ServiceInvoiceSide

	private formatDate(date: Date | string): string {
		return moment(date).format("MM.DD.YYYY");
	}

	private resolveInvoiceTitle(invoice: ServiceInvoice) {
		if (invoice.payer.userId == this.$wss.getCurrent.userId) {
			return invoice.payee.name
		} else {
			return invoice.payer.name
		}
	}

	private voidInvoice(inv: InvoiceDTO<any>) {
		Application.startLoading()
		InvoiceService.decline(inv.id).then(
			() => {
				this.$emit('void')
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

	private completeInvoice(inv: InvoiceDTO<any>) {
		Application.startLoading()
		InvoiceService.complete(inv.id).then(
			() => {
				this.$emit('paid')
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}


	private openLog(log: ServiceRecordDTO) {
		if (this.invoice.service) {
			this.selectedLog = log
			if (log.executor.userId == this.$wss.getCurrent.userId) {
				this.updateLog = true;
			} else {
				this.viewLog = true;
			}
		}
	}

	get total(): string {
		return "$" + this.invoice.total.toLocaleString("en-US", {minimumFractionDigits: 2})
	}
}
